module.exports = __webpack_public_path__ + "static/media/b.cd5c6a6c.png";